<template>
    <div class="resources-folder-card-header">
        <div class="resources-folder-card-file-count">
            <span style="font-size:12px">
                {{ fileCount }}
                <BaseIcon
                    class="noselect"
                    name="file-alt"
                    size="1x"
                    style="font-size: 12px;display:inline-block !important;"
                />
            </span>
        </div>
        <strong style="font-size:14px">{{ title }}</strong>
    </div>
</template>

<script>
export default {
    name: 'ResourcesFolderCardHeader',
    props: {
        title: String,
        fileCount: Number,
    },
};
</script>

<style scoped>
.resources-folder-card-header {
    display: grid;
    grid-template-columns: 1fr 3fr;
    grid-gap: 10px;
    align-items: start;
}
.resources-folder-card-file-count {
    border: 1px solid rgba(0, 0, 0, 0.4);
    border-radius: 5px;
    text-align: center;
    vertical-align: middle;
}
</style>
